/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListTenantResponse {
    getFixupPrototypeFunction() { return ListTenantResponse.fixupPrototype; }

    static newInstance(model: Partial<ListTenantResponse>): ListTenantResponse {
        let obj = Object.assign(new ListTenantResponse(), model);
        ListTenantResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListTenantResponse>): ListTenantResponse {
        if (!model) return null;
        return ListTenantResponse.newInstance(<ListTenantResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListTenantResponse) {
        if (!obj) return;

        models.ListTenantResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListTenantResponse): boolean {
        Object.setPrototypeOf(obj, ListTenantResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tenants) {
            for (let val of this.tenants) {
                models.TenantDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenants List.
     */
    tenants: Array<models.TenantDetails>;

}
